import React, {Suspense, useState} from "react";
import { usePageTitle } from "../../infecto-lms-webapp/hooks/usePageTitle";
import {
	AllNodesSearchContextProvider
} from "../../infecto-lms-webapp/context/search-context/AllNodesSearchContextProvider";
import { SearchTagsFilter } from "../components/search/SearchTagsFilter";
import { CarouselContainer } from "../containers/Carousel.container";
import { SearchNodesCarouselSkeletonComponent } from "../components/search/SearchNodesCarouselSkeleton.component";
import { WideContainerWithTopBar } from "../containers/WideContainerWithTopBar.container";
import { PageMainText } from "../components/PageTitleText";
import { PageDefaultContainer } from "../containers/PageDefaultContainer";
import {ElementTypeV2} from "@generated/NodeScreen_NodeFragment.graphql";
import {SearchNodesCarouselComponent} from "../components/search/search-nodes-carousel";

export const SearchNodesScreen = () => {
	usePageTitle("Suche");
    const [isShowingModules, setIsShowingModules] = useState<ElementTypeV2[]>(["file", "video", "podcast"])

	return (
		<AllNodesSearchContextProvider>
			<PageDefaultContainer collapsed={false} screenName="Suche">
				<WideContainerWithTopBar>
					<div className="flex flex-column">
						<div className="flex flex-column align-items-center xl:align-items-start">
							<PageMainText className="xl:pl-4 pt-4">Module</PageMainText>
							<div className="mt-3 xl:pl-4 flex row w-full justify-content-center lg:justify-content-end">
								<SearchTagsFilter />
							</div>
							{isShowingModules.length == 0 &&
								<PageMainText className="xl:pl-4 pt-4">Keine Module gefunden</PageMainText>
							}
						</div>
						<CarouselContainer className="mt-4">
							<Suspense fallback={<SearchNodesCarouselSkeletonComponent />}>
								<SearchNodesCarouselComponent setIsShowingModules={setIsShowingModules} elementType={"file"} />
							</Suspense>
							<Suspense fallback={<SearchNodesCarouselSkeletonComponent />}>
								<SearchNodesCarouselComponent setIsShowingModules={setIsShowingModules} elementType={"video"} />
							</Suspense>
							<Suspense fallback={<SearchNodesCarouselSkeletonComponent />}>
								<SearchNodesCarouselComponent setIsShowingModules={setIsShowingModules} elementType={"podcast"} />
							</Suspense>
					</CarouselContainer>
					</div>
				</WideContainerWithTopBar>
			</PageDefaultContainer>
		</AllNodesSearchContextProvider>
	);
};
